const initState = {};

const SignalRhubsReducer = (state = initState, action) => {
    switch (action.type) {
        case 'ADD_SIGNALR_CONNECTION':
            return {
                ...state,
                [action.payload.hubName]: action.payload.connection, // Store connection by hub name
            };
        case 'REMOVE_SIGNALR_CONNECTION':
            const newState = { ...state };
            if (newState[action.payload.hubName]) {
                newState[action.payload.hubName].stop(); // Stop connection before removing
                delete newState[action.payload.hubName];
            }
            return newState;
        case 'CLEAR_ALL_CONNECTIONS':
            Object.values(state).forEach(conn => conn.stop()); // Stop all connections
            return {};
        case 'IS_RECONNECTED_HUB':
            return {
                ...state,
                ['Reconnecting' + action.payload.hubName]: action.payload.value, // Store connection by hub name
            };
        default:
            return state;
    }
};

export default SignalRhubsReducer;